import { createContext, useContext } from 'react';

/**
 *
 */
export interface AppInitContextValue {
    initialized: boolean;
    setInitialized: (initialized: boolean) => void;
}

/**
 *
 */
const AppInitContext = createContext<AppInitContextValue | null>(null);

/**
 *
 */
const useAppInitContext = () => {
    const ctx = useContext(AppInitContext);
    if (!ctx) throw new Error('useAppInitContext must be used within AppContextInitializer');
    return ctx;
};

export { AppInitContext, useAppInitContext };
